module.exports = __webpack_public_path__ + "media/devOpsCategory.e7ba98ce4bce17ff0c921eefd6544701.svg";